import { render, staticRenderFns } from "./data_report.vue?vue&type=template&id=becd86d4"
import script from "./data_report.vue?vue&type=script&lang=js"
export * from "./data_report.vue?vue&type=script&lang=js"
import style0 from "./data_report.vue?vue&type=style&index=0&id=becd86d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports